import React, { useContext } from 'react';
import Row from '../common/Row';
import HeaderButton from './HeaderButton';
import UserIcon from '../../svgs/UserIcon';
import BucketIcon from '../../svgs/BucketIcon';
import { CartContext } from '../../ContextAPI';

const TopHeader = () => {
  const { cartItems } = useContext(CartContext);
  const itemCount = cartItems.reduce((total, item) => total + item.qty, 0);

  return (
    <header className="border-b border-slate-200 bg-white/95">
      <div className="mx-auto flex h-[72px] w-full max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <a href="/" className="text-xl font-extrabold tracking-tight text-slate-900">NOVA<span className="text-indigo-600">MARKET</span></a>
        <Row className="items-center gap-4 sm:gap-6">
          <HeaderButton title="Sign up" Icon={UserIcon} url="/signup" />
          <HeaderButton title={`Cart (${itemCount})`} Icon={BucketIcon} url="/cart" />
        </Row>
      </div>
    </header>
  );
};

export default TopHeader;
